/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import { CreateContractV1 } from "../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsApi"; // Import API action to create a contract
import { toast } from "react-toastify"; // Import toast notifications for user feedback
import { Contract } from "../../../../../models/Contract";
import {errorMsg} from "../../../../../Apis/functions"; // Import the Contract model

/**
 * Component logic for creating a new contract.
 *
 * @param {object} t - Translation function (i18next).
 * @param {function} dispatch - Redux dispatch function.
 * @param {function} navigate - Navigation function (e.g., from react-router).
 * @param {object} contract - Contract data object from the form.
 * @param {boolean} isValidStartDate - Validity of the start date.
 * @param {boolean} isValidEndDate - Validity of the end date.
 * @param {function} setEmptyFields - Function to set error state when fields are missing.
 */
const CreateContractApp = ({ t, dispatch, navigate, contract, isValidStartDate, isValidEndDate, setEmptyFields }) => {

    // Function to handle the form submission
    const handleSubmit = () => {
        // Check if required fields are filled and date fields are valid
        if (contract.contractorId && contract.startDate && isValidStartDate && contract.endDate && isValidEndDate) {
            setEmptyFields(false); // Clear error state if everything is valid

            // Convert contract object into the format expected by the API
            const dataToSend = Contract.toRegister(contract);

            // Ensure empty strings are converted to null (required by API)
            Object.keys(dataToSend).forEach((key) => {
                if (dataToSend[key] === '') {
                    dataToSend[key] = null;
                }
            });

            // Clone and sanitize the data again for consistency
            const dataWithNullFields = { ...dataToSend };
            Object.keys(dataWithNullFields).forEach((key) => {
                if (dataWithNullFields[key] === '') {
                    dataWithNullFields[key] = null;
                }
            });

            // Dispatch the action to create the contract
            dispatch(CreateContractV1(dataWithNullFields)).then(
                ({
                     payload: {
                         data: { data, success, code},
                     },
                 }) => {
                    if (success === true) {
                        // Show success message and go back to the previous screen
                        toast.success(t('has_been_created_successfully'));
                        navigate(-1);
                    } else errorMsg(code);
                }
            );
        } else {
            // Set error flag if required fields are missing or invalid
            setEmptyFields(true);
        }
    };

    // Return the handler function to be used in the component's UI
    return {
        handleSubmit,
    };
};

export default CreateContractApp; // Export the component for use in other parts of the application
